import axios from "axios";

const endpoint_url = "/campaignV2/customer/luckyDraw/claimSummary";

const getClaimSummary = ({ luckyDrawUuid }) => {
  return new Promise((resolve, reject) => {
    axios
      .get(endpoint_url, {
        params: { luckyDrawUuid },
      })
      .then((response) => resolve(response.data))
      .catch((error) => {
        return reject(error.response?.data || error);
      });
  });
};

export default getClaimSummary;
